import { Transition } from 'react-transition-group';
import type { TransitionProps } from 'react-transition-group/Transition';

export default Transition as unknown as React.ComponentType<TransitionProps>;
